import {AvailableSteps} from 'api/resources';

export default {
    fields: [
        {
            type: 'availableStepOptions',
            name: 'stepTypesToAdd',
            props: {
                options: AvailableSteps.map(item => ({
                    key: item,
                    value: item,
                    textKey: `add_step.${item}`
                }))
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/AddSteps/addStepFormConfig.js